import { t } from "i18next";
import { ComputeFieldComponent } from "../../computeFields";
import { TitleState } from "../../types";
import { SeparatedList } from "./utils";

export const MainTitleCF: ComputeFieldComponent<{
  title: string;
  titleState?: Partial<TitleState>;
  styled?: boolean;
}> = ({ input, language }) => {
  const styled = input.styled ?? true;

  if (input.titleState?.none) {
    return styled ? (
      <i>{t("computeField.sansTitre", { lng: language })}</i>
    ) : (
      <>{t("computeField.sansTitre", { lng: language })}</>
    );
  }
  if (input.titleState?.unknown) {
    return <>{t("computeField.titreInconnu", { lng: language })}</>;
  }
  if (input.titleState?.notConfirmed) {
    return `[${input.title}]`;
  }
  return styled ? <i>{input.title}</i> : <>{input.title}</>;
};

export const DateCF: ComputeFieldComponent<{
  date?: string;
  unknownDate?: boolean;
  uncertainDate?: boolean;
  /** Conservé pour compat — pas d'effet d'affichage. */
  estimatedDate?: boolean;
}> = ({ input, language }) => {
  if (input.unknownDate || input.date == undefined) {
    return <>{t("computeField.sansDate", { lng: language })}</>;
  }
  const base = String(input.date).replace(/\s+ca\.?\s*$/i, "").trimEnd();
  if (input.uncertainDate) {
    return (
      <>
        {base}
        {t("computeField.dateCirca", {
          lng: language,
          defaultValue: " ca.",
        })}
      </>
    );
  }
  return <>{input.date}</>;
};

export const TitleCF: ComputeFieldComponent<{
  title: string;
  titleState?: Partial<TitleState>;
  date?: string;
  unknownDate?: boolean;
  uncertainDate?: boolean;
  estimatedDate?: boolean;
  subtitle?: string;
  otherTitle?: string;
  secondaryTitleLines?: string[];
  showDate?: boolean;
}> = ({ input, language, lineBreak = true, ...props }) => {
  return (
    <>
      <SeparatedList
        lineBreak={lineBreak}
        language={language}
        input={[
          <SeparatedList
            {...props}
            commaSeparated
            language={language}
            lineBreak={false}
            input={[
              <b>
                <MainTitleCF input={input} language={language} />
              </b>,
              (input.showDate ?? true) && (
                <DateCF input={input} language={language} />
              ),
            ]}
          />,
          ...(input.secondaryTitleLines ?? []),
          input.subtitle,
          input.otherTitle,
        ]}
      />
    </>
  );
};

export const CreditCF: ComputeFieldComponent<{
  credit?: string;
}> = ({ input }) => {
  return input.credit ? <>{`${input.credit}`}</> : null;
};

export const TitlePhotoMasterCF: ComputeFieldComponent<{
  title: string;
  titleState?: Partial<TitleState>;
  date?: string;
  unknownDate?: boolean;
  uncertainDate?: boolean;
  estimatedDate?: boolean;
  location?: string;
  showDate?: boolean;
}> = ({ input, language, lineBreak = true, ...props }) => {
  return (
    <>
      <SeparatedList
        lineBreak={lineBreak}
        language={language}
        input={[
          <SeparatedList
            {...props}
            commaSeparated
            language={language}
            lineBreak={false}
            input={[
              <MainTitleCF input={input} language={language} />,
              input.location,
              (input.showDate ?? true) && (
                <DateCF input={input} language={language} />
              ),
            ]}
          />,
        ]}
      />
    </>
  );
};
